import rotinasCadastro, {
  type RotinasCadastro,
} from "~/composables/menus/rotinas/cadastro/rotinas";

export default function () {
  return rotinasCadastro;
}
